import { computed, inject } from 'vue'
import { RouteRecordName, useRoute, useRouter } from 'vue-router'

export default function useRouterBack() {

const previousRouteName = inject<{ value?: RouteRecordName }>('previousRouteName', {})

const router = useRouter()
const route = useRoute()

const fallbackRouteName = computed(() => route?.meta?.fallbackRouteName)

function goBack() {
  if (previousRouteName?.value) {
    router.back()
  } else if (fallbackRouteName.value) {
    router.push({ name: fallbackRouteName.value as unknown as RouteRecordName })
  }
}
return {
  goBack,
  fallbackRouteName,
}
}
